<div class="page-wrapper">

  <div class="page-header page-header__row">
    <div class="page-header__title-stack">
      <div class="page-title">
        <svg class="page-title__icon" width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect x="2" y="2" width="5" height="5" rx="1" fill="currentColor"/>
          <rect x="9" y="2" width="5" height="5" rx="1" fill="currentColor"/>
          <rect x="2" y="9" width="5" height="5" rx="1" fill="currentColor"/>
          <rect x="9" y="9" width="5" height="5" rx="1" fill="currentColor"/>
        </svg>
        <h1 class="page-title__text">Overview</h1>
      </div>
      <p class="page-title__sub">Totals across every organization.</p>
    </div>

    @if (overview) {
      <div class="page-header__controls">
        <div class="dropdown" (appClickOutside)="closeMenu()">
          <button type="button" class="range-picker" (click)="toggleRangeMenu($event)">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12C12.5523 2 13 2.44772 13 3V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H5V1.5ZM4 5V13H12V5H4Z" fill="currentColor"/>
            </svg>
            {{ rangeLabel() }}
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          @if (rangeMenuOpen) {
            <div class="dropdown__menu dropdown__menu--left">
              @for (opt of rangeOptions; track opt.days) {
                <button
                  type="button"
                  class="dropdown__item"
                  [class.dropdown__item--active]="selectedRangeDays() === opt.days"
                  (click)="selectRange(opt.days)"
                >{{ opt.label }}</button>
              }
            </div>
          }
        </div>
      </div>
    } @else {
      <app-skeleton width="180px" height="36px" radius="4px"></app-skeleton>
    }
  </div>

  <div class="admin-overview-layout">

    <div class="admin-overview-layout__main">
      @if (overview; as ov) {

        <app-platform-stats-row [platform]="ov.platform" [wallets]="ov.wallets"></app-platform-stats-row>

        <app-usage-spend-card
          [current]="ov"
          [rangeDays]="selectedRangeDays()"
        ></app-usage-spend-card>

      } @else {

        <!-- Platform skeleton -->
        <div class="api-card api-card--full">
          <div class="api-card__header">
            <div class="api-card__header-stack">
              <app-skeleton width="80px" height="18px"></app-skeleton>
              <app-skeleton width="220px" height="14px"></app-skeleton>
            </div>
          </div>
          <div class="overview-figures">
            @for (i of [1,2,3,4]; track i) {
              <div class="overview-figure">
                <app-skeleton width="90px" height="14px"></app-skeleton>
                <app-skeleton width="60px" height="28px" radius="6px"></app-skeleton>
                <app-skeleton width="120px" height="14px"></app-skeleton>
              </div>
            }
          </div>
        </div>

        <!-- Usage and spend skeleton -->
        <div class="api-card api-card--full">
          <div class="api-card__header">
            <div class="api-card__header-stack">
              <app-skeleton width="130px" height="18px"></app-skeleton>
              <app-skeleton width="300px" height="14px"></app-skeleton>
            </div>
          </div>
          <div class="overview-figures overview-figures--bordered">
            @for (i of [1,2,3,4,5]; track i) {
              <div class="overview-figure">
                <app-skeleton width="70px" height="14px"></app-skeleton>
                <app-skeleton width="80px" height="28px" radius="6px"></app-skeleton>
                <app-skeleton width="110px" height="14px"></app-skeleton>
              </div>
            }
          </div>
          <table class="billing-table spend-table admin-stack admin-stack--spend">
            <tbody>
              @for (i of [1,2,3,4,5]; track i) {
                <tr>
                  <td class="spend-table__rank"><app-skeleton width="12px" height="14px"></app-skeleton></td>
                  <td><app-skeleton width="60%" height="14px"></app-skeleton></td>
                  <td><app-skeleton width="40px" height="14px"></app-skeleton></td>
                  <td><app-skeleton width="80%" height="6px" radius="99px"></app-skeleton></td>
                  <td><app-skeleton width="50px" height="14px"></app-skeleton></td>
                  <td><app-skeleton width="70px" height="14px"></app-skeleton></td>
                </tr>
              }
            </tbody>
          </table>
        </div>

      }
    </div>

    <div class="admin-overview-layout__divider" aria-hidden="true"></div>

    <div class="admin-overview-layout__aside">
      <!-- Each preview card fetches independently and manages its own
           skeleton state mounted unconditionally so they start loading
           in parallel with the overview fetch, not gated behind it. -->
      <app-organizations-preview-card></app-organizations-preview-card>
      <app-calls-preview-card></app-calls-preview-card>
      <app-transactions-preview-card></app-transactions-preview-card>
      <app-users-preview-card></app-users-preview-card>
    </div>

  </div>

</div>
